<template>
    <DemoComponentDialog ref="demoDialog" v-model="demoUser" @cancel="cancel" @confirm="confirm" />
      <v-container fluid>
  
     <v-row >
        <v-col cols="4" >

            <v-card>
                <v-card-title>User input</v-card-title>

                <v-container>
                    <v-form >
                        <v-text-field 
                            v-model="userInput" 
                            name="userInput" 
                            label="User Input" 
                            placeholder="user input"
                            @keyup.enter="addUserInput"
                            ></v-text-field>
                    </v-form>
                    <v-btn variant="outlined" @click="addUserInput">Add</v-btn>
                </v-container>
            </v-card>
            &nbsp;
            <v-card>
                <v-container>
                <v-card-text class="green">
                        <p>This shows how to display local variables reactively. This will show the current value of the user input field</p>
                    </v-card-text>
                <v-card-title style="color: red;">{{ userInput}}</v-card-title>

 
                </v-container>
            </v-card>
            &nbsp;
            <v-card>
                <v-container>
                    <v-card-text class="green">
                        <p>This shows how to display values from the store </p>
                    </v-card-text>
                    <v-btn variant="outlined" @click="demoStore.updateValue">Increment</v-btn>
                <v-card-title style="color: red;">{{ storeValue}}</v-card-title>

 
                </v-container>
            </v-card>
            &nbsp;
            <v-card>
                <v-card-title> Demo Dialog </v-card-title>
                <v-card-text class="green"> This shows how to use a modal dialog, and how to handle updating data from a child component  </v-card-text>
                <v-container>

                    <v-text-field v-model="demoUser.email" label="Email" disabled></v-text-field>
                    <v-text-field v-model="demoUser.firstName" label="First Name" disabled></v-text-field>
                    <v-text-field v-model="demoUser.lastName" label="Last Name" disabled></v-text-field>
                </v-container>  
                <v-container>
                    <v-btn @click="openDialog">Edit user</v-btn>
                </v-container>

            </v-card>
        </v-col>
        <v-col cols="8" >

                <DemoComponentCard :inputs="userInputList" />

            &nbsp;


                <v-card>
                    <v-card-title>User inputs (Local)</v-card-title>
                    <v-card-text class="green">
                        <p>This shows how to use reactive data within the same view/component (DemoView)</p>
                    </v-card-text>
                    <v-container>
                        <VDataTable
                            :headers="headers"
                            :items="userInputList"
                            :items-per-page="10"
                        >
                        </VDataTable>
                    </v-container>
                </v-card>

        </v-col>
            
        
     </v-row>
  
  
  </v-container>

</template>
<style >

.sidebar {
 border: 2px solid rgb(85, 85, 85);
 padding-left: 1px;
 padding-right: 1px;
 padding-top: 25px;
}



.green {
  color: #3fba49 !important;
}




</style>
<script>
import { ref , computed, onMounted} from 'vue'
import { reactive } from 'vue'


import DemoComponentCard  from '@/components/demo/DemoComponentCard.vue'
import DemoComponentDialog from '@/components/demo/DemoComponentDialog.vue'

import { useDemoStore } from '@/store/demo'
import { VDataTable } from "vuetify/components";




export default {
    setup() {
        const demoStore = useDemoStore()
        const userInput = ref('')       
        const demoDialog = ref(null)    // Creates a reference to the dialog component

        const userInputList = reactive([])
        const demoUser = reactive({ email: 'test@demo.com', firstName: 'John', lastName: 'Doe' })

        const storeValue = computed(() => {
            return demoStore.demoValue
        })

        onMounted(() => {
            
            
        });

        function addUserInput() {
            const timestamp = new Date().toISOString()
            userInputList.push({ input: userInput.value, time: timestamp })
            userInput.value = ''
        }

        function openDialog() {
            demoDialog.value.open()
        }

        
        const headers = ref([
            { align: 'left', title: 'time', key: 'time', sortable: false },
            { align: 'left', title: 'input', key: 'input', sortable: false },
        ]);


        return {
            userInput,
            addUserInput,
            headers,
            userInputList,
            demoDialog,
            openDialog,
            storeValue,
            demoStore,
            demoUser
        };
    },
    components: {
    DemoComponentCard,
    VDataTable,
    DemoComponentDialog
}
}
</script>
